export default __webpack_public_path__ + "envelop3.png?e855b500bab681184f2e4831a6031fb5";